import { render, staticRenderFns } from "./TradeRule.vue?vue&type=template&id=18e99274&scoped=true&"
import script from "./TradeRule.vue?vue&type=script&lang=js&"
export * from "./TradeRule.vue?vue&type=script&lang=js&"
import style0 from "./TradeRule.vue?vue&type=style&index=0&id=18e99274&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e99274",
  null
  
)

export default component.exports